module.exports = __webpack_public_path__ + "img/e92f652.png";